export default "__VITE_ASSET__CYj0tpwK__"